/**
 * AOS (Animate On Scroll)
 * https://github.com/michalsnik/aos
 */

import 'aos/dist/aos.css';
import AOS from 'aos';

AOS.init({
  disable: 'phone',
  duration: 400,
  offset: -80,
  once: true,
});
